/* @flow */
import { RECEIVE_FOUNDRY_RESPONSE } from '../actions/foundry_response';
import type { Action } from '../actions/types';
import extract from '../utils/extract';
import {get} from 'lodash';

type ProductsState = {
  id: number,
  comments_id: string,
  name: string,
  short_name: string,
  product_url: string,
  color: Object,
  category: Object,
  subcategory: Object,
  class: Object,
  images: Array<any>,
  offer: Object,
  updated_at: string,
  sku: string,
  brand: Object,
  is_enabled: boolean,
  description: string,
  created_at: string,
  thumbnail_url: string,
  is_sponsored: boolean,
  click_tracker: string,
  impression_tracker: string,
  entries: Array<any>,
  is_sem3_available: boolean,
  reviews: Array<any>
};

const ENTRY_ATTRIBUTES = [
  'id',
  'url',
  'label',
  'title',
  'truncated_short_title_80',
  'meta.sold_content_type',
  ['contributors', ['display_name']]
];

const shimProductEntries = (entries: Array<Object>): Array<Object> => {
  return entries.map((entry: Object): Object => {
    return extract(entry.object, ENTRY_ATTRIBUTES);
  });
};

const pickState = (content: Object): ProductsState => {
  return {
    ...get(content, 'products[0]'),
    entries: shimProductEntries(get(content, 'entries', []))
  };
};

export default (
  state: ProductsState = pickState({}),
  action: Action
): ProductsState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE: return pickState(action.data.content);
    default: return state;
  }
};
